/**
 * Copyright 2025 Design Barn Inc.
 */

import React from 'react';

export default function PasswordIcon(): React.ReactElement {
  return (
    <div className="flex items-center justify-center rounded-[8px]">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.75 7.54102C2.75 6.02223 3.98122 4.79102 5.5 4.79102H19.5C21.0188 4.79102 22.25 6.02223 22.25 7.54102V17.541C22.25 19.0598 21.0188 20.291 19.5 20.291H5.5C3.98122 20.291 2.75 19.0598 2.75 17.541V7.54102ZM5.5 6.29102C4.80964 6.29102 4.25 6.85066 4.25 7.54102V17.541C4.25 18.2314 4.80964 18.791 5.5 18.791H19.5C20.1904 18.791 20.75 18.2314 20.75 17.541V7.54102C20.75 6.85066 20.1904 6.29102 19.5 6.29102H5.5Z"
          fill="#20272C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.88197 6.11612C4.11663 5.77479 4.58357 5.68832 4.9249 5.92298L12.5 11.1309L20.0751 5.92298C20.4164 5.68832 20.8834 5.77479 21.118 6.11612C21.3527 6.45745 21.2662 6.92438 20.9249 7.15905L12.9249 12.659C12.669 12.835 12.331 12.835 12.0751 12.659L4.0751 7.15905C3.73377 6.92438 3.6473 6.45745 3.88197 6.11612Z"
          fill="#20272C"
        />
      </svg>
    </div>
  );
}
